import { LitEntity, SirenActionMixin, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-surface';
import '../../common/bn-card';

class RoleSelector extends SirenActionMixin(LitEntity) {
  static get styles() {
    return [sharedStyles, css`
      bn-surface.selected {
        background-color: var(--blue-60);
        border: 1px solid var(--blue-60);
      }
      bn-surface.selected > div {
        color: white;
      }
    `];
  }

  render() {
    if (!this.entity) {
      return html``;
    }
    const roles = (this.entity?.getSubEntities('https://api.binsentry.com/rel/role') || []).map(role => {
      const displayProperties = html`
        <div>${role.properties.displayName}</div>
        <div class="subdued">${role.properties.description}</div>
      `;
      if (!role.hasAction('select')) {
        return html`<bn-surface class="selected">${displayProperties}</bn-surface>`;
      } else {
        return html`<bn-card @click="${() => this._selectRole(role)}">${displayProperties}</bn-card>`;
      }
    });
    return html`${roles}`;
  }

  async _selectRole(role) {
    const { entity: actionResult } = await this.submitAction(role.getAction('select'));
    this.entity = actionResult;
    this.dispatchEvent(new CustomEvent('role-selector-updated', { detail: { entity: this.entity } }));
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.dispatchEvent(new CustomEvent('role-selector-updated', { detail: { entity: this.entity } }));
  }
}

window.customElements.define('role-selector', RoleSelector);
